
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import {
  addSelectorToStore,
  createSelectorFromName,
  DEFAULT_SELECTORS_COLLECTION,
  isDuplicateSelector
} from "@/oxygen/classes/lib/classes";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { globalStore } from "@/store/store-accessor";
import NotificationLogger from "@/lib/notifications/notifications";

@Component({
  components: { DropdownInput, NiceButton, TextInput }
})
export default class AddSelector extends Vue {
  newSelectorName: string | null = "";

  @Prop()
  collection?: string | null;

  get collections() {
    return globalStore.oxySelectorsCollections;
  }

  get isSingleClassName() {
    if (!this.newSelectorName) return false;
    const singleClassRegex = /^\.[a-zA-Z0-9_/-]+$/;
    return singleClassRegex.test(this.newSelectorName);
  }

  addSelector() {
    if (!this.newSelectorName) return;

    const finalSelectorName =
      this.isSingleClassName && this.newSelectorName.startsWith(".")
        ? this.newSelectorName.substring(1)
        : this.newSelectorName;

    if (isDuplicateSelector(finalSelectorName)) {
      NotificationLogger.log.errorMessage("This selector already exists.");
      return;
    }

    const customSelector = createSelectorFromName(
      this.newSelectorName,
      null,
      this.isSingleClassName ? "class" : "custom",
      this.collection || DEFAULT_SELECTORS_COLLECTION
    );

    addSelectorToStore(customSelector);
    this.newSelectorName = "";
  }
}
